const page = `

{settings}
document.title: Carolina Neurath
og.title: Carolina Neurath 
og.image: http://quickshot.imgix.net/opinionsbildaren-carolina-neurath/bild1.png?w=1000&auto=format
og.twitterImage: http://quickshot.imgix.net/opinionsbildaren-carolina-neurath/bild1.png?h=120&w=120&auto=format&fit=crop
og.description: Carolina Neurath fick sitt stora genombrott som reporter när en av Sveriges mest rafflande finanshärvor rullades upp. Men priset för att gräva fram oegentligheter är både hot och trakasserier.
og.url: http://pejl.svt.se/opinionsbildaren-carolina-neurath
siteCatalyst.name: opinionsbildaren-carolina-neurath
siteCatalyst.category: lyxartikel
{}
[+page]
{.div}
  style.position:relative
  style.backgroundColor: black
  style.color:white
  style.height: 100%;
  style.marginBottom: -18px;
  [.+content]
  
  
    {.div}
      style.minHeight:70vh
      style.position:relative
      style.paddingBottom:25px
      [.+content]
        {.div}
          style.position:relative
          style.width: 300px
          style.height:45px
          style.top:20px
          style.backgroundImage: url('http://quickshot.imgix.net/annika-beijbom/ob-1-rad-vit-ht_720.png')
          style.backgroundPositionY: 50%
          style.backgroundPositionX: 0%
          style.backgroundSize: cover
          [.+content]
          []
        {}
        
        luft:-50
          rubrik3: Carolina Neurath
          
          {.video}
            id:13157663?autostart=true
            storlek:wide
          {}
          {.citat}    
            citat: Min drivkraft är att hitta oegentligheter i näringslivet – att komma bakom fasaderna.
            cstyle.color:#ddd
          {}
               
      []
    {}
    
    
   
   
 
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-carolina-neurath/bild1.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 40% 40%
      [.+content]
      []
    {}
    
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: KARRIÄREN

            Carolina Neurath fick sitt stora genombrott när en av Sveriges mest rafflande finanshärvor rullades upp. Hon var nyhetsledande reporter i historien om HQ-bankens uppgång och fall.
 
            Hon har även fått revisionsbranschen att betala in rätt skatt och gjort bankernas bolåneräntor synliga - jobb hon tilldelats Stora journalistpriset och Guldspaden för.
             
            - Det har verkligen gått över förväntan. Många får slita en hel journalistkarriär för det här, säger hon.
             
            Carolina växte upp i Segeltorp utanför Huddinge i Stockholm. Hon började tidigt intressera sig för att berätta historier, och redan som tioåring skrev hon noveller.
             
            Nu har fokus flyttats till att gräva fram oegentligheter hos de stora bolagen och dra fram dem i ljuset. Ett arbete förknippat med en del hot, hat och trakasserier.
            luft:
          []
        {}
      []
    {}
    
    
    
    {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:13157711
          storlek:wide
        {}
        {.citat}    
          citat: De man granskar har vässat sina metoder. Det förekommer att man blir förföljd, smygfotad och kartlagd.
          cstyle.color:#ddd
        {}
      []
    {}
    

   
   {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-carolina-neurath/bild2.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 40% 50%
      [.+content]
      []
    {}
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: UPPVÄXTEN
 
            Carolinas föräldrar var egenföretagare. Pappa drev flyttfirma och mamma arbetade tillsammans med hennes mormor och moster i släktens stora tryckeri. En plats Carolina ofta besökte på väg hem från skolan.
             
            - Lukten av trycksvärta och rök låg tung i lokalen. Många satt inomhus och rökte. Det var då jag bestämde mig för att aldrig börja röka, ett löfte jag hållit, säger hon.
             
            Som barn drömde Carolina om att bli veterinär och åka ner till Afrika och rädda bergsgorillor, och under gymnasiet vaknade intresset för samhällsfrågor. I dag brinner hon för jämlikhet och rättvisa.
             
            - Det är otroligt irriterande när stora bolag använder kryphål i lagen för att kunna tillgodose sig själva, eller på annat sätt utnyttjar sin starka ställning gentemot sina kunder.
             
            En annan fråga hon ofta försöker lyfta är mansdominansen inom näringslivet, som är näst intill total när det handlar om advokatbyråer och riskkapitalister.
             
            - Här finns mycket kvar att göra så det kommer jag fortsätta hålla  ögonen på.
             
            Vid sidan om arbetet på tidningen ägnar hon mycket tid i stallet.  
            
            luft:

          []
        {}
      []
    {}
    
    
    
    {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:13157743
          storlek:wide
        {}
        {.citat}    
          citat: Hästlivet har nog lärt mig att bli ganska tuff och hårdhudad.
          cstyle.color:#ddd
        {}
      []
    {}
    
    
    
    
    
   {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-carolina-neurath/bild3.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 40% 50%
      [.+content]
      []
    {}
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: EKONOMIINTRESSET
 
            Intresset för ekonomi bottnar i en tung händelse i barndomen, då Carolinas farmors bror försvann. Han hade gått ner sig genom isen och drunknat.  
            - Han hade aktier som vi ärvde. Efter ett tag började jag handla med dem, vilket ledde till att jag kunde köpa min första häst, säger hon.
             
            Under journalistutbildningen började Carolina Neurath på riktigt intressera sig för ekonomisidorna, och hamnade som nyutexaminerad journalist på Dagens Industri. När finanskrisen rullade in var hon mitt i nyheternas centrum.
             
            - Det var dramatiskt. Aktiekurserna i de stora bolagen kunde snabbt falla över tio procent - en hektisk och händelserik period.
             
            Parallellt med hennes nuvarande jobb på Svenska Dagbladet är hon också skönlitterär författare. Huvudpersonen i böckerna är ekonomijournalist och rör sig i en finansvärld. En av böckerna kommer nu att bli film.
            
            luft:

          []
        {}
      []
    {}
    
    
    
    
     {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:13157759
          storlek:wide
        {}
        {.citat}    
          citat: Under gymnasiet gjorde vi en film där jag var manusförfattare, regissör och spelade huvudrollen – väldigt egocentriskt.
          cstyle.color:#ddd
        {}
      []
    {}
    
    
     {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-carolina-neurath/bild4.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 70% 40%
      [.+content]
      []
    {}
    
    
     {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: PERSONLIGHETEN
 
            För den som blir granskad är journalisten Carolina Neurath envis och jobbig. Hon ger aldrig upp och viker inte för att ställa besvärliga frågor till maktens elit.
             
            Som privatperson är hon motsatsen, berättar hon.
            - Mina vänner beskriver mig alltid som väldigt snäll och omtänksam. Själv skulle jag säga att  jag är snudd på konflikträdd.
             
            Hon har alltid fullt upp, både på jobbet och på fritiden. 
            - Jag vaknade med min familj en ledig lördag för några veckor sedan. Vi gick ner på stan och fikade och åt lunch, och då tänkte jag "herregud är det så här folk har det - vad härligt". Men jag skulle nog inte klara av det så länge.
            En annan sida som Carolina Neurath har jobbat med under åren är prestationsångesten.
            
            
            luft:

          []
        {}
      []
    {}
    
    
    
     {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:13157827
          storlek:wide
        {}
        {.citat}    
          citat: Under perioder när jag presterar mindre, då tror jag snarare att jag försöker hitta någon form av drivkraft i det.
          cstyle.color:#ddd
        {}
      []
    {}
    
    
    
    {.div}
        style.backgroundColor: #eee
        style.color:#111
        style.maxWidth: 600px
        style.padding: 1px 12px
        style.margin: 24px auto 0
        [.+content]
           mellanrubrik: OM CAROLINA NEURATH
           
          {.bild}
            fil:opinionsbildaren-carolina-neurath/bild1.png
            storlek:m
          {}
          
          [Namn:] Anna Carolina Neurath.
          [Född:] I november 1985 i Segeltorp.
          [Familj:] Dottern Judith och maken Niclas Engsäll.
          [Bor:] Östermalm, Stockholm.
          [Gör:] Ekonomijournalist på Svenska Dagbladet, SvD, författare.
          [Aktuell:] Nyligen släppt sina andra roman - Gränslösa - om den unga ekonomijournalisten Beatrice Farkas. Hennes första roman Fartblinda blir sannolikt tv-serie och sänds 2019.
          [Yrkesliv:]  Studerat journalistik vid JMK och Poppius i Stockholm. Tidigare reporter på Dagens Industri. Vann en Guldspade 2010 med SvD-kollegan Jacob Bursell för granskningen av revisionsbranschen. Tilldelades tillsammans med fem SvD-kollegor Stora journalistpriset 2012 för arbetet med räntekartan. Utsedd till en av årets kvinnor av Expressen. Nominerades till Guldspaden även 2011 för boken Den stora Bankhärvan, som skildrar företagskulturen inom HQ-bank.
          [På fritiden:] Ridning, löpning, träffar vänner och arrangerar gärna middagar.
          [Senast lästa bok:] De polyglotta älskarna av Lina Wolff. 
          [Favoritdoft:] Badhusklor - påminner om barndomens resor till fjällen.
          [Samlat på:] Torkade rosor - smög ofta upp på nätterna och klippte av rosor i grannens rabatt under barndomsåren i Segeltorp utanför Huddinge.
          [Dolda talanger:] Armbrytning och är kung på att fickparkera.
          [Berätta något som få vet om:] Hade en tam råtta som satt på axeln när jag åkte rollerblades hemma i Segeltorp.

                    
          luft:
        []
      {}
      
      
      
    
    
    luft:200
    
    rubrik5:Reporter: Magnus Nilsson
    rubrik5:Fotograf: Åke Wehrling
    rubrik5:[SVT Opinion | http://www.svt.se/opinion/om-opinionsbildaren | white | target:_self  ]
    
    {.sharebuttons}
    title: Carolina Neurath
    url: http://pejl.svt.se/opinionsbildaren-carolina-neurath/
    {}
       
    luft:100
   
  []
{}



[]
`;

export default page;





/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/opinionsbildaren-carolina-neurath.js
 **/